<template>
    <div>
        <ClientDashboardComponent/>
    </div>
</template>

<script>

import ClientDashboardComponent from "@/components/ClientComponents/DashboardComponent";

export default {
  name: "client-form-data-view",
  components: { ClientDashboardComponent},
  title: 'ClientFormData',
}
</script>

<style>

</style>
